<template>
    <div class="d-flex justify-content-center">
        <nav aria-label="...">
            <ul class="pagination">
                <li class="page-item" :class="{ 'disabled': currentPage === 1 }">
                    <span class="page-link" @click="handlePrevious">{{ getTranslatedText('previous') }}</span>
                </li>
                <li class="page-item" v-if="currentPage > 3">
                    <a class="page-link" href="#" @click="changePage(1)">1</a>
                </li>
                <li class="page-item" v-if="currentPage > 4">
                    <span class="page-link">...</span>
                </li>
                <li class="page-item" v-for="pageNumber in pages" :key="pageNumber"
                    :class="{ 'active': pageNumber === currentPage }">
                    <a class="page-link" href="#" @click="changePage(pageNumber)">{{ pageNumber }}</a>
                </li>
                <li class="page-item" v-if="currentPage < totalPages - 3">
                    <span class="page-link">...</span>
                </li>
                <li class="page-item" v-if="currentPage < totalPages - 2">
                    <a class="page-link" href="#" @click="changePage(totalPages)">{{ totalPages }}</a>
                </li>
                <li class="page-item" :class="{ 'disabled': currentPage === totalPages }">
                    <a class="page-link" href="#" @click="handleNextPage">{{ getTranslatedText('next') }}</a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";

export default {
    name: 'Pagination',
    mixins: [languageMixins],
    props: {
        currentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },
    computed: {
        pages() {
            const pages = [];
            if (this.totalPages > 0) {
                const minPage = Math.max(1, this.currentPage - 2);
                const maxPage = Math.min(this.totalPages, this.currentPage + 2);
                for (let i = minPage; i <= maxPage; i++) {
                    pages.push(i);
                }
            }
            return pages;
        }
    },
    methods: {
        changePage(pageNumber) {
            this.$emit('change-page', pageNumber);
        },

        handlePrevious() {
            if (this.currentPage > 1) {
                this.$emit('change-page', this.currentPage - 1);
            }
        },

        handleNextPage() {
            if (this.currentPage < this.totalPages) {
                this.$emit('change-page', this.currentPage + 1);
            }
        }
    }
}
</script> 